'use strict';

/**
 * Merge options with default options and return result
 * @param defaults Default options values
 * @param options Specific options values
 * @returns Merged options
 */
export default function mergeOpts(defaults, options) {
    const o = {};
    
    // copy defaults
    for (let prop in defaults) {
        if (Object.prototype.hasOwnProperty.call(defaults, prop)) {
            o[prop] = defaults[prop];
        }
    }
    
    // override defaults
    for (let prop in options) {
        if (Object.prototype.hasOwnProperty.call(options, prop)) {
            o[prop] = options[prop];
        }
    }
    return o;
}
